var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useRef } from 'react';
import { ReactViewController, RootViewController, useAppContext } from '@veeam/core';
import { WizardBuilder } from './ribs/wizard';
import { StepInteractor, WizardInteractor } from './ribs';
import { StepBuilder } from './StepBuilder';
import { WizardRootRouter } from './ribs/WizardRootRouter';
import { WizardViewController } from "./ribs/view/WizardViewController";
import { PageWizardViewController } from "./ribs/view/PageWizardViewController";
export var WIZARD_VIEW_TYPE;
(function (WIZARD_VIEW_TYPE) {
    WIZARD_VIEW_TYPE[WIZARD_VIEW_TYPE["normal"] = 0] = "normal";
    WIZARD_VIEW_TYPE[WIZARD_VIEW_TYPE["page"] = 1] = "page";
})(WIZARD_VIEW_TYPE || (WIZARD_VIEW_TYPE = {}));
function isNormalWizardConfig(config) {
    if (!config.hasOwnProperty('view')) {
        return true;
    }
    return config.view === WIZARD_VIEW_TYPE.normal;
}
function isPageWizardConfig(config) {
    return config.view === WIZARD_VIEW_TYPE.page;
}
function createWizardViewController(config) {
    if (isNormalWizardConfig(config)) {
        return new WizardViewController(config);
    }
    if (isPageWizardConfig(config)) {
        return new PageWizardViewController(config);
    }
    throw new Error('useWizard error: bad config');
}
var FeatureWizardRouter = /** @class */ (function (_super) {
    __extends(FeatureWizardRouter, _super);
    function FeatureWizardRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FeatureWizardRouter;
}(WizardRootRouter));
var EmptyStepInteractor = /** @class */ (function (_super) {
    __extends(EmptyStepInteractor, _super);
    function EmptyStepInteractor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EmptyStepInteractor;
}(StepInteractor));
var EmptyWizardInteractor = /** @class */ (function (_super) {
    __extends(EmptyWizardInteractor, _super);
    function EmptyWizardInteractor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EmptyWizardInteractor;
}(WizardInteractor));
var FeatureWizardBuilder = /** @class */ (function () {
    function FeatureWizardBuilder(interactor, wizardBuilder) {
        this.interactor = interactor;
        this.wizardBuilder = wizardBuilder;
    }
    FeatureWizardBuilder.prototype.build = function () {
        var router = new FeatureWizardRouter(this.interactor, this.wizardBuilder, new RootViewController());
        return { router: router };
    };
    return FeatureWizardBuilder;
}());
export var useWizard = function (configure) {
    var _a;
    var moduleRef = useRef(null);
    var getErrorListener = useAppContext().getErrorListener;
    var catchError = function (e) {
        try {
            getErrorListener().onCatchError(e);
        }
        catch (_a) {
            console.error(e);
        }
    };
    if (!moduleRef.current) {
        var _b = configure(), steps = _b.steps, _c = _b.interactor, interactor = _c === void 0 ? new EmptyWizardInteractor() : _c, config = _b.config, listener = _b.listener;
        var wizardBuilder = new WizardBuilder({
            listener: __assign(__assign({}, listener), { willDone: interactor.willDone.bind(interactor) }),
            viewController: createWizardViewController(config),
            config: {
                isNextStepAvailable: (_a = config.isNextStepAvailable) !== null && _a !== void 0 ? _a : true
            },
            steps: steps.filter(Boolean).map(function (step) {
                var bodyViewController = new RootViewController();
                if (typeof step.render === 'function') {
                    bodyViewController = new ReactViewController({}, step.render.bind(step));
                }
                if (step.viewController) {
                    bodyViewController = step.viewController;
                }
                bodyViewController.texts = step.texts;
                return new StepBuilder(step.interactor || new EmptyStepInteractor(), bodyViewController, step, step.child);
            })
        });
        var builder = new FeatureWizardBuilder(interactor, wizardBuilder);
        try {
            var module_1 = builder.build();
            module_1.router.load();
            moduleRef.current = module_1;
        }
        catch (e) {
            catchError(e);
        }
    }
    useEffect(function () {
        return function () {
            if (moduleRef.current) {
                try {
                    moduleRef.current.router.unload();
                    moduleRef.current = null;
                }
                catch (e) {
                    catchError(e);
                }
            }
        };
    }, []);
    return {
        component: moduleRef.current
            ? moduleRef.current.router.viewController.render()
            : null
    };
};
//# sourceMappingURL=hooks.js.map